/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceEtcResponse,
    DeviceEtcResponseFromJSON,
    DeviceEtcResponseFromJSONTyped,
    DeviceEtcResponseToJSON,
} from './DeviceEtcResponse';
import {
    DeviceStatus,
    DeviceStatusFromJSON,
    DeviceStatusFromJSONTyped,
    DeviceStatusToJSON,
} from './DeviceStatus';
import {
    TagsResponse,
    TagsResponseFromJSON,
    TagsResponseFromJSONTyped,
    TagsResponseToJSON,
} from './TagsResponse';

/**
 * 
 * @export
 * @interface DeviceResponse
 */
export interface DeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    deviceTypeId: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    groupId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DeviceResponse
     */
    createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DeviceResponse
     */
    lastConnectionDate: Date | null;
    /**
     * 
     * @type {DeviceStatus}
     * @memberof DeviceResponse
     */
    lastConnectionStatus: DeviceStatus;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    serialNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    macAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isNewDevice: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    clientVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    loaderVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    firmwareVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    uiVersion: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    customFirmware1Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    customFirmware2Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    customFirmware3Version: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceResponse
     */
    comment: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isSyncWithUpgradeRule: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isTraceEnabledAttributeSet: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isLightResetAttributeSet: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isFullResetAttributeSet: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isMoveToPreproductionAttributeSet: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isLogHistoryAttributeSet: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    loaderUpdateRetryCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    firmwareUpdateRetryCount: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    uiUpdateRetryCount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceResponse
     */
    isLocked: boolean;
    /**
     * 
     * @type {DeviceEtcResponse}
     * @memberof DeviceResponse
     */
    etc: DeviceEtcResponse;
    /**
     * 
     * @type {Array<TagsResponse>}
     * @memberof DeviceResponse
     */
    pendingTags: Array<TagsResponse>;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    loaderCumulativeCount: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    fwCumulativeCount: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceResponse
     */
    uiCumulativeCount: number;
}

export function DeviceResponseFromJSON(json: any): DeviceResponse {
    return DeviceResponseFromJSONTyped(json, false);
}

export function DeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceTypeId': json['deviceTypeId'],
        'groupId': json['groupId'],
        'createdAt': (json['createdAt'] === null ? null : new Date(json['createdAt'])),
        'lastConnectionDate': (json['lastConnectionDate'] === null ? null : new Date(json['lastConnectionDate'])),
        'lastConnectionStatus': DeviceStatusFromJSON(json['lastConnectionStatus']),
        'serialNumber': json['serialNumber'],
        'macAddress': json['macAddress'],
        'isNewDevice': json['isNewDevice'],
        'clientVersion': json['clientVersion'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'customFirmware1Version': json['customFirmware1Version'],
        'customFirmware2Version': json['customFirmware2Version'],
        'customFirmware3Version': json['customFirmware3Version'],
        'comment': json['comment'],
        'isSyncWithUpgradeRule': json['isSyncWithUpgradeRule'],
        'isTraceEnabledAttributeSet': json['isTraceEnabledAttributeSet'],
        'isLightResetAttributeSet': json['isLightResetAttributeSet'],
        'isFullResetAttributeSet': json['isFullResetAttributeSet'],
        'isMoveToPreproductionAttributeSet': json['isMoveToPreproductionAttributeSet'],
        'isLogHistoryAttributeSet': json['isLogHistoryAttributeSet'],
        'loaderUpdateRetryCount': json['loaderUpdateRetryCount'],
        'firmwareUpdateRetryCount': json['firmwareUpdateRetryCount'],
        'uiUpdateRetryCount': json['uiUpdateRetryCount'],
        'isLocked': json['isLocked'],
        'etc': DeviceEtcResponseFromJSON(json['etc']),
        'pendingTags': ((json['pendingTags'] as Array<any>).map(TagsResponseFromJSON)),
        'loaderCumulativeCount': json['loaderCumulativeCount'],
        'fwCumulativeCount': json['fwCumulativeCount'],
        'uiCumulativeCount': json['uiCumulativeCount'],
    };
}

export function DeviceResponseToJSON(value?: DeviceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'deviceTypeId': value.deviceTypeId,
        'groupId': value.groupId,
        'createdAt': (value.createdAt === null ? null : value.createdAt.toISOString()),
        'lastConnectionDate': (value.lastConnectionDate === null ? null : value.lastConnectionDate.toISOString()),
        'lastConnectionStatus': DeviceStatusToJSON(value.lastConnectionStatus),
        'serialNumber': value.serialNumber,
        'macAddress': value.macAddress,
        'isNewDevice': value.isNewDevice,
        'clientVersion': value.clientVersion,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'customFirmware1Version': value.customFirmware1Version,
        'customFirmware2Version': value.customFirmware2Version,
        'customFirmware3Version': value.customFirmware3Version,
        'comment': value.comment,
        'isSyncWithUpgradeRule': value.isSyncWithUpgradeRule,
        'isTraceEnabledAttributeSet': value.isTraceEnabledAttributeSet,
        'isLightResetAttributeSet': value.isLightResetAttributeSet,
        'isFullResetAttributeSet': value.isFullResetAttributeSet,
        'isMoveToPreproductionAttributeSet': value.isMoveToPreproductionAttributeSet,
        'isLogHistoryAttributeSet': value.isLogHistoryAttributeSet,
        'loaderUpdateRetryCount': value.loaderUpdateRetryCount,
        'firmwareUpdateRetryCount': value.firmwareUpdateRetryCount,
        'uiUpdateRetryCount': value.uiUpdateRetryCount,
        'isLocked': value.isLocked,
        'etc': DeviceEtcResponseToJSON(value.etc),
        'pendingTags': ((value.pendingTags as Array<any>).map(TagsResponseToJSON)),
        'loaderCumulativeCount': value.loaderCumulativeCount,
        'fwCumulativeCount': value.fwCumulativeCount,
        'uiCumulativeCount': value.uiCumulativeCount,
    };
}

